import { IonPage, useIonViewWillLeave } from '@ionic/react'
import React from 'react'
import PCRHeader from '../../../../components/pcrHeader/PCRHeader.component'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import HeaderNav from '../../../../components/headerNav/HeaderNav.component'
import VitalsSedationScaleContent from '../content/VitalsSedationScale.content'
import { TabConstants } from '../../../../components/tabs/Tabs.constants'
import { useDispatch } from 'react-redux'
import { checkQuickActionsRedirect } from '../../store/vitals.actions'
import { setScrollTargetID } from '../../../../components/scrollToTopButton/store/scrollToTop.actions'

const VitalsSedationScale: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()

  const onBackClick = () => {
    history.back()
  }

  useIonViewWillLeave(() => {
    if (history.location.pathname !== TabConstants.VITALS_TAB) {
      dispatch(checkQuickActionsRedirect())
    } else {
      dispatch(setScrollTargetID('sedationScaleButton'))
    }
  })

  return (
    <IonPage id='VitalsSedationScaleContent'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        title={t('vitals.sedationScale.title')}
        isBackButton={true}
      />
      <VitalsSedationScaleContent />
    </IonPage>
  )
}

export default VitalsSedationScale
